/* Recherche d'articles. Libelles dans assets/ua-article-search-i18n.js.

   DEUX ENDROITS, DEUX PRESENTATIONS VOULUES
   1. Page blog : on garde la presentation de la liste, memes cartes card-article, meme grille,
      meme pagination, neuf par page. Fragment rendu par templates/search.ua-articles.liquid.
   2. Fenetre de l'entete : produits a gauche, articles a droite des qu'il y a la place. Les
      cartes d'articles reprennent les dimensions des cartes produit du theme, vignette carree
      et titre de meme taille. Donnees par templates/search.ua-json.liquid.

   POURQUOI PAS /search/suggest.json : l'API d'autocompletion ne lit que le titre et le chapeau.
   Mesure du 20/09/2026, « nitrite » y renvoie 0 alors que la vraie recherche trouve l'article,
   le mot etant dans le corps du texte.

   PIEGE SHOPIFY, le pluriel : « nitrites » renvoie 0, « nitrite » renvoie 1. L'index ne ramene
   pas un pluriel a son singulier, d'ou la seconde tentative sans le s final.  */
(function () {
  'use strict';

  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  var LANG = (document.documentElement.lang || 'fr').toLowerCase().split('-')[0];

  function t(key) {
    var tbl = window.UA_SEARCH_I18N || {};
    var k = (window.UA_SEARCH_KEYS || {})[key];
    var row = tbl[LANG] || tbl.fr || [];
    return row[k] || (tbl.fr || [])[k] || '';
  }

  function plural(n, one, many) { return n + ' ' + t(n > 1 ? many : one); }

  var ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ESCAPES[c]; });
  }

  function singular(q) {
    var w = q.split(/\s+/);
    var last = w[w.length - 1];
    if (last.length > 3 && /s$/i.test(last)) { w[w.length - 1] = last.slice(0, -1); return w.join(' '); }
    return null;
  }

  /* --- Feuille de style ------------------------------------------------------- */

  var CSS = [
    '.ua-art-block{margin-top:3.25rem;}',
    '.ua-art-title{font-size:1.4rem;font-weight:700;text-align:center;margin-bottom:.5rem;}',
    '.ua-art-count{text-align:center;font-size:1rem;opacity:.55;margin-bottom:1.75rem;}',
    '.ua-art-none{text-align:center;font-size:1.15rem;font-weight:600;margin:2rem 0;}',
    '.ua-art-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:1.1rem;margin:0 auto;max-width:76rem;}',
    '@media(min-width:640px){.ua-art-grid{grid-template-columns:repeat(3,minmax(0,1fr));}}',
    '@media(min-width:900px){.ua-art-grid{grid-template-columns:repeat(4,minmax(0,1fr));gap:1.35rem;}}',
    '@media(min-width:1200px){.ua-art-grid{grid-template-columns:repeat(5,minmax(0,1fr));}}',
    '.ua-art-card{display:block;text-align:left;}',
    /* Vignette carree, comme .hs-card-media : une carte d'article fait exactement la taille
       d'une carte produit. La photo d'article est en paysage, on la recadre en cover plutot
       que de la laisser en contain, qui laisserait deux bandes vides. */
    '.ua-art-media{aspect-ratio:1/1;border-radius:14px;overflow:hidden;background:color-mix(in srgb, currentColor 5%, transparent);}',
    '.ua-art-media img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .4s ease;}',
    '.ua-art-card:hover .ua-art-media img{transform:scale(1.06);}',
    /* Meme taille et meme position que .hs-card-title, mais en gras : une carte produit a un
       titre puis un prix en gras en dessous, une carte d'article n'a que son titre. Sans ce
       gras la colonne de droite paraissait plus pale que celle de gauche. */
    '.ua-art-name{margin-top:.65rem;font-size:.88rem;line-height:1.3;font-weight:700;}',
    '.ua-art-all{text-align:center;margin-top:2.25rem;}',
    '.ua-art-busy{opacity:.45;transition:opacity .2s ease;}',
    /* Fenetre de l'entete : produits a gauche, articles a droite. La classe est posee sur le
       parent commun des deux zones, et seulement pendant une recherche : au repos la zone de
       gauche porte les recherches frequentes et les offres, qui prennent toute la largeur. */
    '.ua-search-2col{display:grid;grid-template-columns:1fr;gap:2.5rem;}',
    '@media(min-width:1100px){',
    '.ua-search-2col{grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:3rem;align-items:start;}',
    '.ua-search-2col > .ua-art-block{margin-top:0;}',
    '.ua-search-2col .hs-search-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;max-width:none!important;}',
    '.ua-search-2col .ua-art-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;max-width:none;}',
    '}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('ua-art-css')) return;
    var s = document.createElement('style');
    s.id = 'ua-art-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* --- Appels aux deux vues de la recherche ------------------------------------ */

  function searchUrl(view, q, page) {
    var u = ROOT + '/search?view=' + view + '&type=article&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
    return page ? u + '&page=' + page : u;
  }

  function getText(url) {
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  }

  function fetchArticles(q, limit) {
    q = (q || '').trim();
    if (q.length < 2) return Promise.resolve([]);
    limit = limit || 10;
    function ask(term) {
      return getText(searchUrl('ua-json', term)).then(function (txt) {
        try { return JSON.parse(txt.trim()).results || []; } catch (e) { return []; }
      });
    }
    return ask(q).then(function (l) {
      if (l.length) return l.slice(0, limit);
      var s = singular(q);
      return s ? ask(s).then(function (l2) { return l2.slice(0, limit); }) : [];
    });
  }

  function fetchArticleList(q, page) {
    return getText(searchUrl('ua-articles', q, page)).then(function (html) {
      if (page || html.indexOf('ua-art-none') === -1) return html;
      var s = singular(q);
      return s ? getText(searchUrl('ua-articles', s)) : html;
    });
  }

  /* --- Cartes d'articles de la fenetre de l'entete ----------------------------- */

  function cardHTML(a) {
    var media = a.image
      ? '<img src="' + esc(a.image) + '" alt="' + esc(a.alt || a.title) + '" loading="lazy" width="400" height="400">'
      : '';
    return '<a href="' + esc(a.url) + '" class="ua-art-card group" title="' + esc(a.title) + '">' +
      '<div class="ua-art-media">' + media + '</div>' +
      '<div class="ua-art-name">' + esc(a.title) + '</div></a>';
  }

  function blockHTML(list, q) {
    var out = '<p class="ua-art-title">' + esc(t('arts')) + '</p>';
    if (!list.length) return out + '<p class="ua-art-none">' + esc(t('none')) + '</p>';
    out += '<p class="ua-art-count">' + esc(plural(list.length, 'aOne', 'aMany')) + '</p>';
    out += '<div class="ua-art-grid">';
    for (var i = 0; i < list.length; i++) out += cardHTML(list[i]);
    out += '</div><div class="ua-art-all"><a class="btn-underline" href="' + ROOT +
      '/search?type=article&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '">' +
      esc(t('all')) + '</a></div>';
    return out;
  }

  /* --- Page blog --------------------------------------------------------------- */

  function initBlog() {
    var input = document.getElementById('blog-search-field');
    var target = document.getElementById('blog-search-results');
    if (!input || !target) return;
    var list = document.getElementById('articles-list');
    var anchor = document.getElementById('blog-search-top');
    if (input.form) input.form.addEventListener('submit', function (e) { e.preventDefault(); });

    var timer = null;
    var seq = 0;

    function inject(html) {
      /* On retire data-component="FrameAnchor" des liens de pagination : c'est le mecanisme de
         navigation interne du theme, qui tenterait de recharger des zones absentes de ce
         fragment. La pagination est reprise juste en dessous. */
      target.innerHTML = html.replace(/\sdata-component="FrameAnchor"/g, '');
      target.classList.remove('ua-art-busy');
    }

    function run() {
      var q = input.value.trim();
      var mine = ++seq;
      if (q.length < 2) {
        target.innerHTML = '';
        target.classList.remove('ua-art-busy');
        if (list) list.style.display = '';
        return;
      }
      if (list) list.style.display = 'none';
      target.classList.add('ua-art-busy');
      fetchArticleList(q).then(function (html) { if (mine === seq) inject(html); });
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 300); });
    input.addEventListener('search', run);

    target.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="view=ua-articles"]') : null;
      if (!a) return;
      e.preventDefault();
      var mine = ++seq;
      target.classList.add('ua-art-busy');
      getText(a.getAttribute('href')).then(function (html) {
        if (mine !== seq) return;
        inject(html);
        if (anchor) window.scrollTo({ top: anchor.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
      });
    });

    if (input.value.trim().length >= 2) run();
  }

  /* --- Fenetre de recherche de l'entete ---------------------------------------- */

  function initHeader() {
    var modal = document.querySelector('[data-component="Search"]');
    if (!modal) return;
    var input = modal.querySelector('input[name="q"]');
    var container = modal.querySelector('[data-ref="container"]');
    if (!input || !container) return;

    /* Pas de classe container ici : le bloc est insere a l'interieur du .container de la
       fenetre, l'y remettre doublerait la gouttiere laterale. */
    var block = document.createElement('div');
    block.className = 'ua-art-block';
    var wrap = container.parentNode;
    wrap.insertBefore(block, container.nextSibling);

    var timer = null;
    var seq = 0;

    function run() {
      var q = input.value.trim();
      var mine = ++seq;
      if (q.length < 2) {
        block.innerHTML = '';
        block.classList.remove('ua-art-busy');
        wrap.classList.remove('ua-search-2col');
        return;
      }
      wrap.classList.add('ua-search-2col');
      block.classList.add('ua-art-busy');
      fetchArticles(q, 10).then(function (l) {
        if (mine !== seq) return;
        block.innerHTML = blockHTML(l, q);
        block.classList.remove('ua-art-busy');
      });
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 300); });
    input.addEventListener('search', run);
    if (input.value.trim().length >= 2) run();

    /* RECHERCHES FREQUENTES.
       Les puces etaient de simples liens vers la page de resultats : on quittait la fenetre et
       on tombait sur une presentation qui n'a rien a voir avec celle qu'on vient de voir. On
       les traite maintenant comme une frappe au clavier : on remplit le champ et on previent
       la page, ce qui declenche a la fois la recherche produits du theme et la notre. */
    modal.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('.hs-chip') : null;
      if (!chip) return;
      e.preventDefault();
      input.value = (chip.textContent || '').trim();
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      try { input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'e' })); } catch (err) {}
    });

    /* Le theme reecrit le contenu de [data-ref="container"] a chaque frappe. Apres chaque
       reecriture on remet trois choses :
       - le titre de l'espace produits, qui repond a celui des articles ;
       - le compte de produits ecrit comme celui des articles. Le theme ecrivait
         « 6 produit(s) trouve(s) » a cote de « 9 articles trouves » ; on accorde vraiment ;
       - le message d'absence de resultat, que le theme ecrivait « Pas de resultats » alors
         qu'il n'avait cherche que dans les produits. */
    var obs = new MutationObserver(function () {
      var empty = container.querySelector('.hs-noresult');
      if (empty && !empty.dataset.uaDone) {
        empty.dataset.uaDone = '1';
        empty.textContent = t('noneProd');
      }
      var count = container.querySelector('.hs-results-count');
      if (count && !count.dataset.uaDone) {
        var m = (count.textContent || '').match(/\d+/);
        if (m) { count.dataset.uaDone = '1'; count.textContent = plural(parseInt(m[0], 10), 'pOne', 'pMany'); }
      }
      var grid = container.querySelector('.hs-search-grid');
      if (!grid) return;
      var parent = grid.parentNode;
      if (parent.querySelector('.ua-prod-title')) return;
      var h = document.createElement('p');
      h.className = 'hs-section-title ua-prod-title';
      h.textContent = t('prods');
      parent.insertBefore(h, parent.querySelector('.hs-results-count') || grid);
    });
    obs.observe(container, { childList: true, subtree: true });
  }

  function init() { injectCSS(); initBlog(); initHeader(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.uaArticleSearch = { fetch: fetchArticles, list: fetchArticleList };
})();
